import { render } from "./OurContact.vue?vue&type=template&id=b61013ba&scoped=true"
import script from "./OurContact.vue?vue&type=script&lang=js"
export * from "./OurContact.vue?vue&type=script&lang=js"

import "./OurContact.vue?vue&type=style&index=0&id=b61013ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61013ba"]])

export default __exports__